import { ApiState } from '../state/types';

export const selectRawCampaign = (state: ApiState, campaignId: string) => {
  return state.rawCampaigns[campaignId];
};
